export default __webpack_public_path__ + "static/media/billboard_poster_reduced.6dd13d70.jpg";